import React, { memo, useEffect, useState } from "react";
import stylesPc from "./PresenterCard.module.css";
import stylesSp from "./PresenterCard_SP.module.css";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import { Button, createStyles, makeStyles, Snackbar, Theme } from "@material-ui/core";
import { resetfilter } from "../../../common/video/VideoFilterActions";
import { FilteredUserInfo } from "../../models/UserFilter";
import { UserData } from "../../../user/User";
import { isAdmin, isEditor } from "../../../utils/LogicUtils";
import { AppState } from "../../../root/RootReducer";
import { changeMenu } from "../../../root/components/layout/header/HeaderActions";
import { VerticalList } from "../../../common/homePage/model/HomePage";
import { useSpring, animated } from "react-spring";
// import ProjectIcon from "@material-ui/icons/Work";
import VideoIcon from "@material-ui/icons/Theaters";
import PuiTypography from "../../../components/elements/PuiTypography";
import classNames from "classnames";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import {
    addRecProfessional,
    removeRecProfessional,
} from "../../../common/homePage/HomePageActions";
import Alert from "@material-ui/lab/Alert";
import { IsDevice } from "../../../components/function/useDeviceFlag";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        addUserIcon: {
            position: "absolute",
            top: "5px",
            right: "5px",
            fontSize: "30px",
            cursor: "pointer",
            color: "var(--red)",
        },
        tag: {
            marginRight: IsDevice("desktop") ? "10px" : "5px",
            marginTop: "7px",
            borderRadius: "2px",
            boxShadow: "none",
            color: " var(--loading-bg)",
            backgroundColor: "#292E36",
            textTransform: "none",
            textAlign: "center",
            padding: "6px 8px 8px",
            fontSize: "14px",
            fontWeight: "normal",
            lineHeight: "12px",
            margin: "auto 0",
            fontFamily: "noto-sans-cjk-jp",
        },
    })
);

interface PresenterCardProps {
    userInfo?: UserData;
    filteredUserInfo?: FilteredUserInfo;
    recProList?: VerticalList[];
    link?: string;
    openMsg?: (event: React.MouseEvent, flg: boolean, name: string) => void;
}

function PresenterCard({
    userInfo,
    filteredUserInfo,
    recProList,
    link,
    openMsg,
}: PresenterCardProps) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;
    const classes = useStyles();
    const dispatch = useDispatch();

    const { user, recommendProfessionalList } = useSelector((state: AppState) => ({
        user: state.user.userInfo,
        recommendProfessionalList: state.recommendList.recommendProfessionalList,
    }));

    const userName = userInfo ? userInfo.fullName : filteredUserInfo ? filteredUserInfo.name : "";
    const userId = userInfo
        ? parseInt(userInfo.id)
        : filteredUserInfo
        ? parseInt(filteredUserInfo.id)
        : -1;
    const userSkills = userInfo ? userInfo.skills : filteredUserInfo ? filteredUserInfo.skills : "";
    const imageUrl = userInfo
        ? userInfo.imageUrl
        : filteredUserInfo
        ? filteredUserInfo.imageUrl
        : "";
    const contentCount = userInfo ? 0 : filteredUserInfo ? filteredUserInfo.contentCount : 0;
    const isVisibleNewIcon = filteredUserInfo ? filteredUserInfo.visibleNewIcon : false;
    const recPro = recProList?.filter((recPro) => parseInt(recPro.id) === userId);
    const [isAdded, setIsAdded] = React.useState(recPro ? recPro.length > 0 : false);

    // const clickInfoIcon = (id: number, name: string) => {
    //     const professionalFilter = {
    //         id: id === -1 ? [] : [id.toString()],
    //         professional: name === "" ? [] : [name],
    //         program:[], project:[], tag:[]
    //     };

    //     dispatch(resetfilter(professionalFilter));
    //     dispatch(changeMenu("/presenter", "/project", "right"));
    // };

    const clickProfile = (id: number, name: string) => {
        const professionalFilter = {
            id: id === -1 ? [] : [id.toString()],
            professional: name === "" ? [] : [name],
            program: [],
            project: [],
            tag: [],
        };

        dispatch(resetfilter(professionalFilter));
        setTimeout(() => dispatch(changeMenu("/presenter", "/" + link, "right")), 100);
    };

    const [isLimitRecommendProfessionals, ChangeLimitRecommendProfessionals] =
        React.useState(false);
    const [recommendProfessionalNum, ChangeRecommendProfessionalNum] = React.useState(0);

    const addRecommendPro = (event: React.MouseEvent) => {
        if (recommendProfessionalNum < 10) {
            dispatch(addRecProfessional(userId));
            setIsAdded(!isAdded);
            if (openMsg) {
                openMsg(event, isAdded, userName);
            }
            event.nativeEvent.stopImmediatePropagation();
        } else {
            ChangeLimitRecommendProfessionals(true);
        }
    };

    const CloseLimitRecommendProfessionalBar = () => {
        ChangeLimitRecommendProfessionals(false);
    };

    const removeRecommendPro = (event: React.MouseEvent) => {
        if (user) dispatch(removeRecProfessional(userId, parseInt(user.id)));
        setIsAdded(!isAdded);

        if (openMsg) {
            openMsg(event, isAdded, userName);
        }

        event.nativeEvent.stopImmediatePropagation();
    };

    const [flipped, setFlipped] = useState(IsDevice("desktop") ? false : true);
    const { transform, opacity } = useSpring({
        opacity: flipped ? 1 : 0,
        transform: `perspective(1000px) rotateY(${flipped ? 180 : 0}deg)`,
        config: { mass: 5, tension: 500, friction: 80 },
    });

    const handleMouseEnter = (event: React.MouseEvent) => {
        if (!IsDevice("desktop")) return;
        setFlipped(true);
    };

    const handleMouseLeave = (event: React.MouseEvent) => {
        if (!IsDevice("desktop")) return;
        setFlipped(false);
    };

    useEffect(() => {
        ChangeRecommendProfessionalNum(Object.keys(recommendProfessionalList).length);
    }, [recommendProfessionalList]);

    if (!link) {
        return (
            <div className={styles.profile}>
                <img
                    className={styles.picture}
                    src={imageUrl}
                    onError={(e) =>
                        (e.currentTarget.src = require("../../../assets/image/noPresenterImage.svg"))
                    }
                    alt=""
                />
                <div>
                    <PuiTypography size={IsDevice("iphone") ? 16 : 20} bold={true}>
                        {userName}
                    </PuiTypography>
                </div>
                <div>
                    <PuiTypography
                        size={IsDevice("iphone") ? 14 : 16}
                        color="gray-61"
                    >{`${contentCount} contents`}</PuiTypography>
                </div>
            </div>
        );
    }

    return (
        <div
            className={styles.container}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <animated.div
                className={styles.card}
                style={{
                    opacity: opacity.interpolate((o) => 1 - Number(o)),
                    transform,
                    zIndex: flipped === false ? 50 : 10,
                }}
            >
                {isVisibleNewIcon && (
                    <img
                        src={require("../../../assets/image/newIcon.svg")}
                        className={styles.newIcon}
                        alt={`newIcon_${userId}`}
                    />
                )}
                {!isAdded && (isAdmin(user?.roles) || isEditor(user?.roles)) && (
                    <PersonAddIcon
                        color="secondary"
                        className={classes.addUserIcon}
                        onClick={addRecommendPro}
                    />
                )}
                {isAdded && (isAdmin(user?.roles) || isEditor(user?.roles)) && (
                    <RemoveCircleOutlineIcon
                        color="secondary"
                        className={classes.addUserIcon}
                        onClick={removeRecommendPro}
                    />
                )}
                <div className={styles.link}>
                    <div key={userName} className={styles.profile}>
                        <img
                            className={styles.picture}
                            src={imageUrl}
                            onError={(e) =>
                                (e.currentTarget.src = require("../../../assets/image/noPresenterImage.svg"))
                            }
                            alt=""
                        />
                        <div>
                            <PuiTypography size={IsDevice("iphone") ? 16 : 20} bold={true}>
                                {userName}
                            </PuiTypography>
                        </div>
                        <div>
                            <PuiTypography
                                size={IsDevice("iphone") ? 14 : 16}
                                color="gray-61"
                            >{`${contentCount} contents`}</PuiTypography>
                        </div>
                        {userSkills && (
                            <div className={styles.skillRow}>
                                {userSkills.length > 0 &&
                                    userSkills.map((skill) => (
                                        <Button
                                            key={skill.id}
                                            size="small"
                                            color="secondary"
                                            variant="contained"
                                            className={classes.tag}
                                        >
                                            {skill.skill}
                                        </Button>
                                    ))}
                            </div>
                        )}
                    </div>
                </div>
            </animated.div>

            <animated.div
                className={classNames(styles.card, styles.cardBack)}
                style={{
                    opacity,
                    transform: transform.interpolate((t) => `${t} rotateY(180deg)`),
                    zIndex: flipped === true ? 50 : 10,
                }}
            >
                {isVisibleNewIcon && (
                    <img
                        src={require("../../../assets/image/newIcon.svg")}
                        className={styles.newIcon}
                        alt={`newIcon_${userId}`}
                    />
                )}
                {!isAdded && (isAdmin(user?.roles) || isEditor(user?.roles)) && (
                    <PersonAddIcon
                        color="secondary"
                        className={classes.addUserIcon}
                        onClick={addRecommendPro}
                    />
                )}
                {isAdded && (isAdmin(user?.roles) || isEditor(user?.roles)) && (
                    <RemoveCircleOutlineIcon
                        color="secondary"
                        className={classes.addUserIcon}
                        onClick={removeRecommendPro}
                    />
                )}
                <div className={styles.link}>
                    <div key={userName} className={styles.profile}>
                        <img
                            className={styles.picture}
                            src={imageUrl}
                            onError={(e) =>
                                (e.currentTarget.src = require("../../../assets/image/noPresenterImage.svg"))
                            }
                            alt=""
                        />
                        <div>
                            <PuiTypography
                                size={IsDevice("iphone") ? 16 : 20}
                                bold={true}
                                color="white"
                            >
                                {userName}
                            </PuiTypography>
                        </div>
                        <div>
                            <PuiTypography
                                size={IsDevice("iphone") ? 14 : 16}
                                color="white"
                            >{`${contentCount} contents`}</PuiTypography>
                        </div>
                        {/* <Link to={"project"} className={styles.backIconLink}>
                            <div className={styles.backIcon} onClick={() => clickInfoIcon(userId, userName)}>
                                <ProjectIcon color="secondary" style={{fontSize: 38, marginRight: "10px", color: "var(--red)"}}/>
                                <PuiTypography size={20} bold={true} color="white">Project</PuiTypography>
                            </div>
                            <ArrowForwardIosIcon style={{color: "white"}} onClick={() => clickInfoIcon(userId, userName)}/>
                        </Link> */}
                        <Link to={link} className={styles.backIconLink}>
                            <>
                                <div
                                    className={styles.backIcon}
                                    onClick={() => clickProfile(userId, userName)}
                                >
                                    <VideoIcon className={styles.videoIcon} />
                                    <PuiTypography size={20} bold={true} color="white">
                                        {"Content"}
                                    </PuiTypography>
                                </div>
                                <ArrowForwardIosIcon
                                    className={styles.arrowIcon}
                                    style={{ color: "white" }}
                                    onClick={() => clickProfile(userId, userName)}
                                />
                            </>
                        </Link>
                    </div>
                </div>
            </animated.div>

            <Snackbar
                autoHideDuration={3000}
                onClose={CloseLimitRecommendProfessionalBar}
                open={isLimitRecommendProfessionals}
            >
                <Alert severity="error">
                    おすすめPresenterはすでに10人登録されているので追加できません
                </Alert>
            </Snackbar>
        </div>
    );
}

export default memo(PresenterCard);
